// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    "production": false,
    "client_id": "165260fe0fe5cc748d410b28de8a0507b71867303540ca954965a73ef24b286e",
    "client_secret": "ed6dfa321221783e7963855a2b8d47d46cdcc879e79463c3f3b40f2dadc825e7",
    "environment": "staging",
    "pusher_app_key": "aa64e5ec9aa892831806",
    "pusher_app_cluster": "us2",
    "statement_document_id": 1,
    "statement_user_document_type_id": 99,
    "accounts_user_document_type_id": 3,
    "docusign_user_document_type_id": [4, 5],
    "gtm_file": "gtm_qa.js",
    "api_server": "",
    "fusion_chart_key":"fdF6tkgD3B1D8A3C2B3D1H2B1B1A7C8A3dwC-9F2A2pvtjF-11C2E1nzkC11C2C7C3B2E2H3E3B1B6C7E2D1D3B4E3bH-7C-21A4B4C2wE2F2D1jixD1B5D1fbqA32B13B9jrE-11G4H3D3G1A15A1A8C7E3E1A2qyB-22A4B8BD2A-9D-8nF1B5B8gvE6YA3H4blB-16A5E4F4F1F1F1E3B2C8A6E2C5C4E2e==",
    "amplitude_api_key": "1fd580e0e3c2b333fa43ccc0b4fd2b6e"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
